module.exports = __webpack_public_path__ + "img/caas3m.e6054b33.jpg";